import axios from "axios";
import {apiURL} from "../config/global-params";

axios.defaults.baseURL = apiURL;

const responseBody = (response) => response.data;

const requests = {
    get: (url) => axios.get(url).then(responseBody),
    post: (url, body) => axios.post(url, body).then(responseBody),
    patch: (url, body, headers) => axios.patch(url, body,
        {
            headers: {
                'Content-Type': 'application/merge-patch+json',
                'Accept': 'application/ld+json'
            }
        }
    ).then(responseBody),

    put: (url, body) => axios.put(url, body).then(responseBody),
    delete: (url) => axios.delete(url).then(responseBody),
}

const News = {
    'apiName': 'newsletters',
    postEmail: (body) => requests.post(News.apiName, body)
}
const DarkAgentDemos = {
    'apiName': 'dark_agent_demo_requests',
    postEmail: (body) => requests.post(DarkAgentDemos.apiName, body)
}
const RedAgentDemos = {
    'apiName': 'red_agent_demo_requests',
    postEmail: (body) => requests.post(RedAgentDemos.apiName, body)
}
const BlueAgentDemos = {
    'apiName': 'blue_agent_demo_requests',
    postEmail: (body) => requests.post(BlueAgentDemos.apiName, body)
}
const CTIDarkiForceDemos = {
    'apiName': 'c_t_i_and_darki_force_demo_requests',
    postEmail: (body) => requests.post(CTIDarkiForceDemos.apiName, body)
}
const Contact = {
    'apiName': 'contact_messages',
    postMessage: (body) => requests.post(Contact.apiName, body)
}
const Subject = {
    'apiName': 'subjects',
    getSubjects: (body) => requests.get(Subject.apiName + '?published=true')
}

const agent = {
    News,
    Contact,
    Subject,
    DarkAgentDemos,
    RedAgentDemos,
    CTIDarkiForceDemos,
    BlueAgentDemos
}

export default agent;